module.exports = __webpack_public_path__ + "assets/img/plants.9d256f6c.webp";